import { Component, Input, ElementRef, ViewChild } from '@angular/core';
import { ColorifyPalette, CanColor, Colorify } from '../core/behaviors/colorify';

@Component({
  selector: 'wi-box',
  template: '<div #box class="box"><ng-content></ng-content></div>'
})
export class BoxComponent extends Colorify implements CanColor {
  @Input() bgColor: ColorifyPalette;
  /** private docs */
  @ViewChild('box') public selector: ElementRef;
  constructor(el: ElementRef) {
    super(el);
  }
}
